import type { ComponentPropsWithoutRef, ElementType, Ref } from 'react';

import { cn } from '@/lib/utils';
import type { Sx } from '@/shared/types/uiTypes';

export type ButtonBaseProps<C extends ElementType = 'button'> = ComponentPropsWithoutRef<C> & {
  component?: C;
  disableRipple?: boolean;
  sx?: Sx;
};

export const ButtonBase = <C extends ElementType = 'button'>({
  className,
  component,
  disableRipple: _disableRipple,
  sx: _sx,
  type,
  ...props
}: ButtonBaseProps<C> & { ref?: Ref<HTMLButtonElement> }) => {
  const Component = component ?? 'button';

  return (
    <Component
      className={cn(
        'inline-flex items-center justify-center rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
        className
      )}
      type={Component === 'button' ? (type ?? 'button') : undefined}
      {...props}
    />
  );
};

ButtonBase.displayName = 'ButtonBase';
